import { Event } from 'schema-dts';
import { JsonLd } from './JsonLD';

function EventSchema(props: { locale?: string }) {
  const eventSchema: Event =
    props?.locale === 'en'
      ? {
          '@type': 'Event',
          name: 'سيتي سكيب مصر 2025',
          description:
            'استكشف أفضل العروض العقارية والخصومات الحصرية من كبرى الشركات من خلال ناوي في معرض سيتي سكيب أكبر معرض عقاري في مصر.',
          location: {
            '@type': 'Place',
            name: 'مركز مصر للمعارض الدولية',
            address: {
              '@type': 'PostalAddress',
              addressLocality: 'القاهرة الجديدة',
              addressCountry: 'مصر'
            }
          },
          startDate: '2025-09-24',
          endDate: '2025-09-27',
          url: 'https://www.nawy.com/ar/real-estate-offers'
        }
      : {
          '@type': 'Event',
          name: 'Cityscape Egypt 2025',
          description:
            'Explore the best real estate offers and exclusive discounts from top companies through Nawy at Cityscape, the largest real estate exhibition in Egypt',
          location: {
            '@type': 'Place',
            name: 'Egypt International Exhibition Center',
            address: {
              '@type': 'PostalAddress',
              addressLocality: 'New Cairo',
              addressCountry: 'Egypt'
            }
          },
          startDate: '2025-09-24',
          endDate: '2025-09-27',
          url: 'https://www.nawy.com/real-estate-offers'
        };

  return JsonLd<Event>('event-schema', {
    '@context': 'https://schema.org',
    ...eventSchema
  });
}

export default EventSchema;
